module.exports = __webpack_public_path__ + "static/media/close.9eea5567.svg";